import React from 'react';
import Item from "../../components/list/Item";
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">
      <Meta
        title="The Staff Engineer's Path"
        desc="A guide to navigating the staff engineer role by Tanya Reilly"
        keyword="staff engineer, leadership, engineering"
        image="/images/books/the-staff-engineers-path.jpg"
        pageType="book"
        author="Tanya Reilly"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/the-staff-engineers-path.jpg"
                alt="The Staff Engineer's Path book"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                The Staff Engineer's Path
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Tanya Reilly</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Tanya Reilly answers the question that many senior engineers face: what does a
                staff engineer actually do? Moving beyond the senior level means your impact is
                no longer measured by the code you write alone. This book provides a practical
                guide to the three pillars of staff-level work: big-picture thinking, project
                execution, and leveling up the engineers around you.
              </p>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Drawing from her experience at Google and Squarespace, Tanya covers how to
                build technical vision, navigate ambiguity, drive cross-team projects, and
                have influence without authority. She is honest about the challenges too —
                the loneliness of the role, the difficulty of saying no, and the tension
                between writing code and doing the less visible work that keeps organizations
                moving forward.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Whether you are already at the staff level, aiming for it, or managing
                staff engineers, this book gives you a clear map of what the role looks
                like in practice.
              </p>
            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
